"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _stylitas = require("@creditas/stylitas");

var _typography = require("@creditas-lab/typography");

var _styleUtilities = require("@creditas-lab/style-utilities");

const Container = _stylitas.styled.div`
  text-align: center;
  margin-bottom: 8px;

  ${_styleUtilities.media.md`
    margin-bottom: 0;
  `}
`;
exports.Container = Container;
Container.Value = (0, _stylitas.styled)(_typography.Typography)`
  font-size: 96px;
  line-height: 112px;
  display: inline-block;
  letter-spacing: 2px;

  ${_styleUtilities.media.sm`
    font-size: 112px;
  `}

  ${_styleUtilities.media.md`
    font-size: 144px;
    line-height: 144px;
  `}
`;
Container.Exponent = (0, _stylitas.styled)(_typography.Typography)`
  display: inline-block;
  font-size: 22px;
  line-height: 44px;
  letter-spacing: 0.5px;

  ${_styleUtilities.media.md`
    font-size: 32px;
    line-height: 48px;
  `}
`;